import teamAssignment from 'components/application/entryBlocks/blocks/teamAssignment';

export default {
	...teamAssignment,
};
